import { Country } from '@afterpaytouch/portal-api/types'
import { BASE_PATH } from '../src/env'
import { Theme } from '@afterpaytouch/core'

const BRONTE_ICON = [BASE_PATH, 'favicon.ico'].join('/')
const CASH_ICON = [BASE_PATH, 'cash', 'favicon.ico'].join('/')

type CountryCode = keyof typeof Country

type FaviconByCountry = {
  [key in CountryCode]?: string
} & {
  default: string
}

const FAVICON_BY_THEME: Record<Theme, FaviconByCountry> = {
  [Theme.AP]: {
    default: BRONTE_ICON,
  },
  [Theme.Pegasus]: {
    [Country.US]: CASH_ICON,
    default: BRONTE_ICON,
  },
  [Theme.Cash]: {
    default: CASH_ICON,
  },
}

export const getFaviconHref = (theme = Theme.AP, country = Country.AU): string => {
  return FAVICON_BY_THEME[theme][country] || FAVICON_BY_THEME[theme].default
}
